import Resource from './common/resource';

class Files extends Resource {
  path = 'files';

  onLoad({ dispatch, commit }, { model, res }) {
    const data = res.data;
    if (data?.results) {
      if (data.page > 1) {
        commit('setSome', {
          action: 'append',
          records: data.results,
        });
      } else {
        commit('setAll', data.results);
      }

      commit('setPagination', data);

      // Load ingestion status separately
      const file_ids = data.results.map((f) => f.id);
      if (file_ids.length > 0) {
        dispatch('files/loadIngestionStatus', file_ids, { root: true });
      }
    } else {
      commit('setAll', data);
    }
  }

  onCreateOne({ dispatch, commit }, { model, res }) {
    dispatch('users/sendAchievement', 'imported_files', { root: true });

    if (!res?.data?.id) return;

    commit('update', {
      model,
      update: res.data,
      action: 'prepend',
    });

    // Load ingestion status separately
    dispatch('files/loadIngestionStatus', [res.data.id], { root: true });
  }
}

export default Files;
